import { render, staticRenderFns } from "./UploadArquivo.vue?vue&type=template&id=4d132aa6&scoped=true&lang=pug"
import script from "./UploadArquivo.vue?vue&type=script&lang=js"
export * from "./UploadArquivo.vue?vue&type=script&lang=js"
import style0 from "./UploadArquivo.vue?vue&type=style&index=0&id=4d132aa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d132aa6",
  null
  
)

export default component.exports